import { Option } from '@mews-commander/types';

type RequiredParams = 'value' | 'label';
type CreateOptionParams<S extends string = string> = Pick<Option<S>, RequiredParams> &
    Partial<Omit<Option<S>, RequiredParams>>;

export const createOption = <S extends string = string>({
    value,
    label,
    disabled = false,
    secondaryText = null,
    indent = false,
    inactive = false,
}: CreateOptionParams<S>): Option<S> => ({
    value,
    label,
    secondaryText,
    disabled,
    indent,
    inactive,
});
